// Validation constants
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 128,
  EMAIL_MAX_LENGTH: 254,
  NAME_MAX_LENGTH: 100,
} as const;

export const VITE_META_DEV = import.meta.env.DEV;
export const VITE_META_PROD = import.meta.env.PROD;
export const VITE_META_MODE = import.meta.env.MODE;
export const VITE_META_SSR = import.meta.env.SSR;

export const SUPPORTED_CHAINS = ['D9', 'TRON', 'BSC'] as const;

export const CHAIN_ICONS = {
  D9: '/images/icon/d9.png',
  TRON: '/images/icon/tron.png',
  BSC: '/images/icon/bsc.png',
};

export const SUPPORTED_TOKENS = ['USDT'] as const;
export const TOKEN_ICONS = {
  USDT: '/images/icon/usdt.png',
};

export type WebsiteSupportedChains = (typeof SUPPORTED_CHAINS)[number];
export type SupportedTokens = (typeof SUPPORTED_TOKENS)[number];

export { default as D9_USDT_ABI } from './d9-usdt-abi';
export { default as EVM_USDT_ABI } from './evm-usdt-abi';
export { default as TRON_USDT_ABI } from './tron-usdt-abi';

export const APP_NAME = 'D9 Cross Chain Transfer';
export const APP_LOGO_URL = `${location.origin}/favicon.webp`;

export const IS_IN_D9_APP = window.navigator.userAgent.includes('d9wallet');
